export const SET_SETTING = 'SET_SETTING';
export const RESET_SETTING = 'RESET_SETTING';
